function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsClose, vsDiffAdded, vsDiffRemoved, vsWarning } from '@deephaven/icons';
import { useDebouncedCallback, useResizeObserver } from '@deephaven/react-hooks';
import CopyButton from "./CopyButton.js";
import Button from "./Button.js";
import "./ErrorView.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Component that displays an error message in a textarea so user can scroll and a copy button.
 */
function ErrorView(_ref) {
  var message = _ref.message,
    _ref$isExpanded = _ref.isExpanded,
    isExpandedProp = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'Error' : _ref$type,
    onDismiss = _ref.onDismiss;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpandable = _useState2[0],
    setIsExpandable = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  var viewRef = useRef(null);
  var textRef = useRef(null);
  var handleResize = useCallback(() => {
    if (isExpanded || isExpandedProp || textRef.current == null) {
      return;
    }
    var newIsExpandable = textRef.current.scrollHeight > textRef.current.clientHeight;
    setIsExpandable(newIsExpandable);
  }, [isExpanded, isExpandedProp]);
  var debouncedHandleResize = useDebouncedCallback(handleResize, 100);
  useResizeObserver(viewRef.current, debouncedHandleResize);
  useLayoutEffect(debouncedHandleResize, [debouncedHandleResize]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('error-view', {
      expanded: isExpanded || isExpandedProp
    }),
    ref: viewRef,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "error-view-header",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "error-view-header-text",
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: vsWarning
        }), /*#__PURE__*/_jsx("span", {
          children: type
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "error-view-buttons",
        children: [/*#__PURE__*/_jsx(CopyButton, {
          UNSAFE_className: "error-view-copy-button",
          tooltip: "Copy error contents",
          copy: "".concat(type, ": ").concat(message).trim()
        }), (isExpandable || isExpanded) && !isExpandedProp && /*#__PURE__*/_jsx(Button, {
          kind: "danger",
          className: "error-view-expand-button",
          onClick: () => {
            setIsExpanded(!isExpanded);
          },
          icon: isExpanded ? vsDiffRemoved : vsDiffAdded,
          children: isExpanded ? 'Show Less' : 'Show More'
        }), onDismiss != null && /*#__PURE__*/_jsx(Button, {
          kind: "danger",
          className: "error-view-dismiss-button",
          onClick: onDismiss,
          icon: vsClose,
          children: "Dismiss"
        })]
      })]
    }), /*#__PURE__*/_jsx("pre", {
      className: "error-view-text",
      ref: textRef,
      children: message
    })]
  });
}
export default ErrorView;
//# sourceMappingURL=ErrorView.js.map